import { Avatar, colors, IconButton, Typography } from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import AvatarEngineer from 'src/assets/images/technician.png';
import logger from 'src/utils/logger';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2)
  },
  authUser: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& $body': {
      backgroundColor: colors.green[100],
    }
  },
  inner: {
    display: 'flex',
    maxWidth: 500
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  body: {
    backgroundColor: colors.grey[100],
    color: theme.palette.text.primary,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 2)
  },
  content: {
    marginTop: theme.spacing(1)
  },
  footer: {
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));


function ConversationMessage({ message, className }) {
  const classes = useStyles();
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: "0", ErrorDescription: "İşleminiz başarı ile gerçekleştirildi." });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const history = useHistory();

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const YorumSil = () => {
    confirmAlert({
      message: 'Yorumunuz silinecektir. Onaylıyor musunuz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => YorumSilEvet()
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }
  const YorumSilEvet = () => {
    const dataMessage  = [{
      AppNr: message.BASVURU_NO,
      ServiceShopId: message.BIRIM_KODU,
      CommentRequested: 0,
      UserId: message.TEKNISYEN_KODU,
      Comment: '',
      Operation: 0,
      CommentId: message.SIRA_NO_PARAM,
      Decision: 0,
    }];
    const configMessage = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('/SetArtemisComment', dataMessage , configMessage ).then(response => {
      let ResponseDataMessage  = response.data;
      setresponseMessage(ResponseDataMessage );
      if (ResponseDataMessage.ErrorCode === "0") {
        history.push("/chat");
      } else {
        setUyariTip("error");
        setUyari(true);
      }
    }).catch(error => {
      setresponseMessage({ ErrorCode: 10, ErrorDescription: "Bir hata oluştu!.." })
      setUyariTip("error");
      setUyari(true);
            logger.error("Hata detayı:", error.message);
    });
  }
  return (
    <div className={clsx(classes.root, { [classes.authUser] : parseInt(message.sender.authUser) === 1 || message.sendername.includes('-Servis')}, className)}>
      {
        uyari && <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />
      }
      <div className={classes.inner}>
        <Avatar className={classes.avatar}
          src={(parseInt(message.sender.authUser) === 1) ? message.sender.avatar : AvatarEngineer} />
        <div>
          <div className={classes.body}>
            <div>
              <Typography variant="h6">
                {message.sender.authUser ? <div></div> : message.sendername}
              </Typography>
            </div>
            <div className={classes.content}>
              <Typography
                color="inherit"
                variant="body1">
                {message.content}
              </Typography>
            </div>
          </div>
          <div className={classes.footer}>
            <Typography
              className={classes.time}
              variant="body2">
              {message.created_at}
            </Typography>
            {
              (parseInt(message.sender.authUser) === 1) &&
              <IconButton size="small" onClick={() => YorumSil()}>
                <HighlightOffIcon color="error" />
              </IconButton>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

ConversationMessage.propTypes = {
  className: PropTypes.string,
  message: PropTypes.object.isRequired
};

export default ConversationMessage;
